import {
  SHOW_EMBED_DIALOG,
  HIDE_EMBED_DIALOG,
} from '../actions/embed';

export const embedDialogOpen = (state = false, action) => {
  switch (action.type) {
    case SHOW_EMBED_DIALOG:
      return true
    case HIDE_EMBED_DIALOG:
      return false
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/embed.js